import { Grid, Typography } from "@mui/material";
import React from "react";

const InvoiceBreakFastByLocation = ({ invoiceDetails }) => {
  return (
    <>
      {Object.keys(invoiceDetails.summary)
        .filter((key) => key !== "costAndMinGurantee")
        .map((summary, i) => {
          return (
            <Grid
              item
              xs={2}
              key={i}
              sx={{ borderLeft: `${i > 0 ? "1px solid #C1C1C2" : ""}` }}
            >
              <Typography variant="body2" fontWeight="bold">
                {summary}
              </Typography>
              <Typography variant="body1">
                {invoiceDetails?.summary[summary]}
              </Typography>
            </Grid>
          );
        })}
    </>
  );
};

export default InvoiceBreakFastByLocation;
